export default class Skill {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
    this.point = Number(data.point);
  }

  get formattedPoint() {
    return trimTailZeros(this.point);
  }
}

/**
 * 小数の末尾から不要な0を取り除く
 *
 * @param {number} val
 * @returns {string}
 */
function trimTailZeros(val) {
  return val.toLocaleString(undefined, { maximumFractionDigits: 3 });
}
